<p-toast></p-toast>

<!-- Page Header -->
<div class="page-header">
  <h1 class="page-title">Forms</h1>
  <div class="header-actions">
@if (canImport) {
      <button class="btn-outline" type="button" (click)="openImportModal()" [disabled]="isReadOnly">
        <i class="ri-download-line"></i>
        <span>Import</span>
      </button>
    }
    @if (canCreate) {
      <button class="btn-primary" type="button" (click)="newFormMenu.toggle($event)" [disabled]="isReadOnly">
        <i class="ri-add-line"></i>
        <span>New Form</span>
      </button>
      <p-menu #newFormMenu [model]="newFormMenuItems" [popup]="true"></p-menu>
    }
  </div>
</div>

<!-- Forms Table -->
<div class="table-container">
  @if (loading) {
    <div class="table-loading">
      <i class="ri-loader-4-line ri-spin"></i>
      <span>Loading...</span>
    </div>
  } @else {
    <table class="data-table">
      <thead>
        <tr>
          <th class="col-name sortable" (click)="onSort('templateName')">
            <span>Template Name</span>
            <i class="sort-icon" [class]="getSortIcon('templateName')"></i>
          </th>
          <th class="col-shortcode sortable" (click)="onSort('shortCode')">
            <span>Short Code</span>
            <i class="sort-icon" [class]="getSortIcon('shortCode')"></i>
          </th>
          <th class="col-count sortable" (click)="onSort('formCount')">
            <span>Count</span>
            <i class="sort-icon" [class]="getSortIcon('formCount')"></i>
          </th>
          <th class="col-status sortable" (click)="onSort('status')">
            <span>Status</span>
            <i class="sort-icon" [class]="getSortIcon('status')"></i>
          </th>
          <th class="col-actions">Actions</th>
        </tr>
      </thead>
      <tbody>
        @if (filteredFolders.length === 0) {
          <tr>
            <td colspan="5">
              <div class="empty-state">
                <i class="ri-inbox-line"></i>
                <p class="empty-title">No form templates found</p>
                <p class="empty-subtitle">Click "Import" to add form templates to this project</p>
              </div>
            </td>
          </tr>
        } @else {
          @for (folder of filteredFolders; track folder.id; let odd = $odd) {
            <tr [class.row-alt]="odd">
              <td class="col-name">
                <span
                  class="template-name"
                  [class.template-name--active]="folder.status === 'Published'"
                  [class.template-name--disabled]="folder.status !== 'Published'"
                  (click)="folder.status === 'Published' && navigateToFormDetail(folder.id)"
                  [title]="folder.status !== 'Published' ? 'This template must be published before viewing forms' : ''">
                  {{ folder.templateName }}
                </span>
              </td>
              <td class="col-shortcode">
                <span class="cell-text">{{ folder.shortCode || '-' }}</span>
              </td>
              <td class="col-count">
                <span class="cell-text">{{ folder.formCount }}</span>
              </td>
              <td class="col-status">
                <span class="status-badge" [ngClass]="getStatusClass(folder.status)">{{ folder.status }}</span>
              </td>
              <td class="col-actions">
                @if (canPublish) {
                  <button
                    class="action-dots-btn"
                    type="button"
                    (click)="showActionMenu($event, actionMenu, folder)"
                    [disabled]="isProjectInactive"
                    title="Actions">
                    <i class="ri-more-2-line"></i>
                  </button>
                }
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  }
</div>

<p-menu #actionMenu [model]="actionMenuItems" [popup]="true"></p-menu>
